import { Component, OnInit } from '@angular/core';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from '../../../app.component';

@Component({
  selector: 'app-leadership-team',
  templateUrl: './leadership-team.component.html',
  styleUrls: ['./leadership-team.component.scss']
})
export class LeadershipTeamComponent implements OnInit {

  baseUrl = myGlobals.baseFileUrl;
  constructor(private service: LandingServiceService) { }

  leadership: any = [];

  ngOnInit(): void {
    this.getLeadership();
  }

  getLeadership() {
    this.service.getAllLeadershipHome().subscribe(data => this.setLeadership(data));

  }
  setLeadership(data) {
    this.leadership = []
    for (let i = 0; i < data['leadership'].length; i++) {
        this.leadership.push(data['leadership'][i])
    }
}

}
